import { Loader } from '@googlemaps/js-api-loader'
import { useEffect, useEffectEvent, useState } from 'react'
import { GOOGLE_API_KEY } from '@/utils/env'

const googleLoader = new Loader({
  apiKey: GOOGLE_API_KEY,
  libraries: ['places'],
})

export function useGoogleLoader() {
  const [scriptLoaded, setScriptLoaded] = useState(false)

  const loadGoogle = useEffectEvent(() => {
    if ((window as any).google) {
      // if window.google object is already available just use it
      setScriptLoaded(true)
      return
    }
    void googleLoader.load().then(() => setScriptLoaded(true))
  })

  useEffect(() => {
    loadGoogle()
  }, [])

  return {
    scriptLoaded,
  }
}
